import { ReactNode } from 'react';
import styled from 'styled-components';

type StatusBoxContentProps = {
  content: ReactNode;
  statusLabel: string;
  statusColor: string;
};
export const StatusBoxContent = ({
  content,
  statusLabel,
  statusColor,
}: StatusBoxContentProps) => {
  return (
    <StyledContainer statusColor={statusColor}>
      <p>{content}</p>
      <div className='status-display'>
        <span className='status-display-label'>New status:</span>
        <span className='status-display-tag'>{statusLabel}</span>
      </div>
    </StyledContainer>
  );
};

type StyledContainerProps = {
  statusColor: string;
};
const StyledContainer = styled.div<StyledContainerProps>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  p {
    margin: 0;
    padding: 0;
  }

  div.status-display {
    display: flex;
    gap: 8px;

    align-items: center;
    font-size: 12px;
    line-height: 16px;

    .status-display-label {
      font-weight: 600;
    }
    .status-display-tag {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 6px;
      height: 24px;

      background-color: ${({ statusColor }) => statusColor};
      border-radius: 4px;
      color: #fff;
    }

    @media (max-width: 960px) {
      flex-direction: column;
      align-items: start;
    }
  }
`;
